import { ModifierDto } from '@symphony-solo/domain/modifiers/src';
import { PriceLevelDto } from '@symphony-solo/domain/price-levels/src';
import { PriceDto } from '@symphony-solo/domain/select-product/src';
import { TransactionLineProductDto, TransactionProductDto } from '../dtos';
import { TransactionUnitPriceBuilder } from './transaction-unit-price.builder';

export class TransactionLineProductBuilder {
  private transactionLineProduct: TransactionLineProductDto;

  constructor() {
    this.transactionLineProduct = new TransactionLineProductDto();
  }

  public setLineIsCorrected(lineIsCorrected: boolean): TransactionLineProductBuilder {
    this.transactionLineProduct.lineIsCorrected = lineIsCorrected;
    return this;
  }

  public addTransactionProduct(id: number, name: string): TransactionLineProductBuilder {
    this.transactionLineProduct.product = new TransactionProductDto(id, name);
    return this;
  }

  public setTaxRate(taxRate: number): TransactionLineProductBuilder {
    this.transactionLineProduct.taxRate = taxRate;
    return this;
  }

  public setQuantity(quantity: number): TransactionLineProductBuilder {
    this.transactionLineProduct.quantity = quantity;
    return this;
  }

  public setNetPrice(netPrice: number): TransactionLineProductBuilder {
    this.transactionLineProduct.netPrice = netPrice;
    return this;
  }

  public setTaxAmount(taxAmount: number): TransactionLineProductBuilder {
    this.transactionLineProduct.taxAmount = taxAmount;
    return this;
  }

  public setGrossPrice(grossPrice: number): TransactionLineProductBuilder {
    this.transactionLineProduct.grossPrice = grossPrice;
    return this;
  }

  public setUnitPrice(modifier: ModifierDto, priceLevel: PriceLevelDto, price: PriceDto): TransactionLineProductBuilder {
    const transactionUnitPrice = new TransactionUnitPriceBuilder()
      .setModifier(modifier)
      .setPriceLevel(priceLevel)
      .setPortionSize(modifier.portionSize)
      .setOriginalPrice(price.value)
      .build();
    this.transactionLineProduct.unitPrice = transactionUnitPrice;
    return this;
  }

  public build(): TransactionLineProductDto {
    return this.transactionLineProduct;
  }
}
